import React, { useState, useEffect } from 'react';
import styles from './Table.module.css';
import { useClaimInvoiceStore } from '../lib/state';
import classNames from 'classnames';

const addVisualText = {
    labor: 'Additional Repair',
    partsMarkup: 'Part',
    partsmarkup: 'Part',
    parts: 'Part',
    trip: 'Additional Trip',
    laborSelectRate: 'Additional Repair',
    refrigerant: 'Reclaim'
};

export const AddRowButton = ({ tableType, invoiceId, contract, hideRow = false }) => {
    const [addTableRow, getTableData, currentInvoice, getReplacementDetails] = useClaimInvoiceStore((state) => {
        return [state.addTableRow, state.getTableData, state.currentInvoice, state.getReplacementDetails];
    });
    const data = getTableData(invoiceId, tableType);
    const [disableAddRow, setDisableAddRow] = useState(false);
    const replacementDetails = getReplacementDetails();

    useEffect(() => {
        if (replacementDetails?.length > 0) {
            const availableSerialNumbers = data?.[0]?.asset?.options?.map((option) => option.serialNumber);
            const selectedSerialNumbers = replacementDetails?.map((row) => row.asset?.selected?.[0]?.serialNumber);
            const isSerialNumbersUtilized = availableSerialNumbers?.every((serialNumber) =>
                selectedSerialNumbers.includes(serialNumber)
            );
            if (tableType === 'labor' || tableType === 'laborSelectRate') {
                if (isSerialNumbersUtilized) {
                    setDisableAddRow(true);
                } else {
                    setDisableAddRow(false);
                }
            }
            if (tableType === 'parts' || tableType === 'partsMarkup') {
                const allOptionsSelected =
                    data[0]?.asset?.options.every((option) =>
                        data.some((row) =>
                            row.asset?.selected?.some((selected) => selected?.assetId === option.assetId)
                        )
                    ) ?? false;
                if (isSerialNumbersUtilized && allOptionsSelected) {
                    setDisableAddRow(true);
                } else {
                    setDisableAddRow(false);
                }
            }
        } else {
            setDisableAddRow(false);
        }
    }, [data, replacementDetails]);

    const handleAddRow = (e) => {
        e.preventDefault();
        addTableRow(invoiceId, tableType, data, contract, replacementDetails);
    };
    return (
        !hideRow && (
            <button
                className={classNames(
                    styles.addRowBtn,
                    data?.length > 1 && tableType === 'trip'
                        ? styles.disableBtn
                        : data?.length > 24
                          ? styles.disableBtn
                          : ''
                )}
                onClick={handleAddRow}
                disabled={disableAddRow}
            >
                + {addVisualText[tableType] ?? 'Row'}
            </button>
        )
    );
};
